import { Trans } from '@lingui/react/macro';
import { Box, Typography } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useWorkflowCheck } from 'app/domains/workflows/features/WorkflowCheckProvider';
import { ManualApproverItem } from './ManualApproverItem';
import { SelectManualApprovers } from './SelectManualApprovers';
import { useWorkflowApprovers } from '../WorkflowApproversProvider';
export function ManualApprovers() {
    const { approvalResult } = useWorkflowCheck();
    const { selectedApprovers, toggleApprover } = useWorkflowApprovers();
    const suggestedApproverIds = approvalResult.approvers.map((approver) => approver.id);
    const manualApprovers = selectedApprovers
        .filter((approver) => !suggestedApproverIds.includes(approver.id))
        .map((approver) => (Object.assign(Object.assign({}, approver), { selected: true, onChange: () => toggleApprover(approver) })));
    return (<Box flexDirection="column" gap="md">
      <SelectManualApprovers />

      {manualApprovers.length > 0 && (<Box flexDirection="column" gap="md">
          <Box alignItems="center" gap="md">
            <Falcon icon="eye" $color="gray.800"/>
            <Typography $fontSize="tiny" $appearance="200">
              <Trans comment="Document approval check - Additional approvers">Additional approvers</Trans>
            </Typography>
          </Box>
          {manualApprovers.map((approver) => (<ManualApproverItem key={approver.id} {...approver}/>))}
        </Box>)}
    </Box>);
}
